import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Timer from "@material-ui/icons/Timer";
import Domain from "@material-ui/icons/Domain";
import Form from "./form";
import { useBreadcrumbs } from "../../../../../../../../../../../../../contexts/breadcrumb";
import { useAttendanceLocalDepartmentQueueServiceTimeComplementCreate } from "../../../../../../../../../../../../../services/api-tansquery/attendance-local/department/queue/service-time/complement/create";

export default function FormCreate() {
    const { setBreadcrumbs } = useBreadcrumbs();
    const { slug, department_id, queue_id } = useParams<{ slug: string; department_id: string; queue_id: string; }>();
    const mutation = useAttendanceLocalDepartmentQueueServiceTimeComplementCreate();

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Locais de Atendimento",
                    path: "/locais-de-atendimento",
                    icon: Domain,
                },
                {
                    label: "Setor",
                    path: `/locais-de-atendimento/${slug}/setor/${department_id}`,
                    icon: Domain,
                },
                {
                    label: "Configuração de Tempo (Serviços Complementares)",
                    path: `/locais-de-atendimento/${slug}/setor/${department_id}/fila/${queue_id}/tempo-servicos-complementares`,
                    icon: Timer
                },
                {
                    label: "Gerenciar",
                    path: "",
                }
            ];
        });
    }, [setBreadcrumbs, department_id, queue_id, slug]);

    return (
        <Form
            unidade={slug}
            fila_id={Number(queue_id)}
            setor_unidade={Number(department_id)}
            mutation={mutation}
        />
    );
}
